"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCAGR = exports.calculateUpsideDownside = exports.DCF_YEARS = void 0;
exports.DCF_YEARS = 5;
function calculateUpsideDownside(fairPrice, currentPrice) {
    if (!currentPrice || !fairPrice)
        return 0;
    return ((fairPrice - currentPrice) / currentPrice) * 100;
}
exports.calculateUpsideDownside = calculateUpsideDownside;
function calculateCAGR(endValue, startValue, years) {
    if (!startValue || !endValue || years <= 0)
        return 0;
    var ratio = endValue / startValue;
    if (ratio <= 0)
        return 0;
    return (Math.pow(ratio, (1 / years)) - 1) * 100;
}
exports.calculateCAGR = calculateCAGR;
//# sourceMappingURL=fair-price-shared.js.map